import { render } from "./BackgroundPaper.vue?vue&type=template&id=13b25a80&scoped=true"
import script from "./BackgroundPaper.vue?vue&type=script&lang=js"
export * from "./BackgroundPaper.vue?vue&type=script&lang=js"

import "./BackgroundPaper.vue?vue&type=style&index=0&id=13b25a80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13b25a80"

export default script